module.exports = __webpack_public_path__ + "img/messages-small-light-green.610d25d4.svg";